import { BriefContactFields } from "@/components/brief/BriefContactFields";
import { BriefProjectFields } from "@/components/brief/BriefProjectFields";

export const BriefForm = ({ form, busy, error, setField, onSubmit }) => (
  <form
    onSubmit={onSubmit}
    className="flex min-h-0 flex-1 flex-col overflow-y-auto overscroll-contain px-5 py-6 sm:px-9 sm:py-8"
    data-lenis-prevent
    data-testid="brief-form"
    aria-busy={busy}
  >
    {error && (
      <p role="alert" data-testid="brief-error" className="mb-6 border border-[#d4ff00]/40 p-3 text-sm text-[#e5e5e5]">
        {error}
      </p>
    )}
    <fieldset disabled={busy} className="min-w-0 space-y-6">
      <BriefContactFields form={form} setField={setField} />
      <BriefProjectFields form={form} setField={setField} />
    </fieldset>
    <button
      type="submit"
      disabled={busy}
      data-testid="brief-submit"
      className="group relative mt-9 shrink-0 overflow-hidden border border-[#d4ff00] px-8 py-5 disabled:opacity-50"
    >
      <span className="absolute inset-0 translate-y-full bg-[#d4ff00] transition-transform duration-500 ease-swift group-hover:translate-y-0" />
      <span className="relative label text-[#d4ff00] transition-colors duration-300 group-hover:text-[#0a0a0a]">
        {busy ? "Submitting..." : "START THE PROJECT →"}
      </span>
    </button>
  </form>
);